export default function VideoPopup() {
    const loadMore= document.querySelector('.alm-load-more-btn');
    let blocks = document.querySelectorAll('.gallery-2__wrapper-block_video--js');
    setTimeout(() => {
        blocks = document.querySelectorAll('.gallery-2__wrapper-block_video--js');
            blocks.forEach((item,index)=>{
                document.querySelectorAll('.gallery-2__wrapper-block_video-open')[index].addEventListener('click', function(){
                    document.querySelectorAll('.gallery-2__block-modal--js')[index].classList.add('active');
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].play();
                })
                document.querySelectorAll('.gallery-2__block-modal_close--js')[index].addEventListener('click', function(){
                    document.querySelectorAll('.gallery-2__block-modal--js')[index].classList.remove('active');
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].pause();
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].currentTime = 0;
                })
                document.querySelectorAll('.gallery-2__block-modal_overlay--js')[index].addEventListener('click', function(){
                    document.querySelectorAll('.gallery-2__block-modal--js')[index].classList.remove('active');
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].pause();
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].currentTime = 0;
                })
            })
      }, 1000);
    
    loadMore.addEventListener('click', function () {
    blocks = document.querySelectorAll('.gallery-2__wrapper-block_video--js');
    setTimeout(() => {
        blocks = document.querySelectorAll('.gallery-2__wrapper-block_video--js');
            blocks.forEach((item,index)=>{
                document.querySelectorAll('.gallery-2__wrapper-block_video-open')[index].addEventListener('click', function(){
                    document.querySelectorAll('.gallery-2__block-modal--js')[index].classList.add('active');
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].play();
                })
                document.querySelectorAll('.gallery-2__block-modal_close--js')[index].addEventListener('click', function(){
                    document.querySelectorAll('.gallery-2__block-modal--js')[index].classList.remove('active');
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].pause();
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].currentTime = 0;
                })
                document.querySelectorAll('.gallery-2__block-modal_overlay--js')[index].addEventListener('click', function(){
                    document.querySelectorAll('.gallery-2__block-modal--js')[index].classList.remove('active');
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].pause();
                    document.querySelectorAll('.gallery-2__block-modal_video--js')[index].currentTime = 0;
                })
            })
      }, 1000);
    })
}
  